(function ($) {
  var that = {};
  that.currentModComments = {};
  that.commentsTopCount = 5;

  that.votingClickHandler = function () {
    // catch the upvote/downvote action
    $('#ticker').find('div.comment-weight-container').find("span > a ").off().on('click', that.addSingleVotingClickHandler);
  };

  that.votingTop5ClickHandler = function () {
    // catch the upvote/downvote action
    $('#top5').find('div.comment-weight-container').find("span > a ").off().on('click', that.addSingleVotingClickHandler);
  };

  /**
   * jump to selected chapter
   *
   * @param player vimeo player object
   * @param dataSelector elements with data-vimeo-timestamp
   * @param targetSelector relative selector for click handler
   */
  that.addVimeoChapterLinks = function(player, dataSelector, targetSelector) {
    $(dataSelector).each(function(){
      var time = $(this).attr("data-vimeo-timestamp");

      if(time) {
        var a = time.split(':'); // split it at the colons
        var seconds = 0;
        //seconds
        if (a.length === 1 && isNumeric(a[0])) {
          seconds = a[0];
        }
        // mm:ss
        else if (a.length === 2) {
          seconds = ((+a[0]) * 60 + (+a[1]));
        }
        // hh:mm:ss
        else if (a.length === 3) {
          seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
        }
        if (seconds) {
          var el_tmp = $(this);
          if (targetSelector) {
            el_tmp = el_tmp.find(targetSelector);
          }
          el_tmp.click(function (e) {
            e.preventDefault();
            player.play();
            player.setCurrentTime(seconds);
          });
        }
      }
    });
  };

  that.addSingleVotingClickHandler = function (e) {
    e.preventDefault();
    var value = 0;
    var comment_id = "" + $(this).data('commentId');
    var in_top5 = false;

    if (comment_id.indexOf("top5-") === 0) {
      comment_id = comment_id.substr(5);
      in_top5 = true;
    }
    comment_id = parseInt(comment_id);

    if ($(this).hasClass('vote-up')) {
      value = 'upvote';
    } else if ($(this).hasClass('vote-down')) {
      value = 'downvote';
    }

    if(getLibObject('config').websocketSuccess) {
      var sendToNode = {
        blogId: sage_js.blog_id,
        sessionId: ajax_variables.post_id,
        message: {
          commentId: comment_id,
        }
      };
      getLibObject("helper").log(sendToNode);

      var eventName = 'frontend-comment-vote';

      getLibObject("websocket").socket.emit(eventName, sendToNode);
    }
  };

  that.onCommentReload = function () {
    that.votingClickHandler();
  };

  that.onTop5Reload = function () {
    that.votingTop5ClickHandler();
    that.initVimeoChapterLinks();
  };

  that.initVimeoChapterLinks = function(){
    var iframe = $("#video").find(" > iframe.vimeo_player");
    // needs check if is vimeo
    if(iframe.length &&
      (iframe.attr("src") !== getLibObject("player").iframeBlank) &&
      (iframe.attr("src").indexOf("vimeo.com") > -1) ) {
      try {
        var player = new Vimeo.Player(iframe);
        that.addVimeoChapterLinks(player,"#comments-top5 > ol > li", false);
      } catch (e) {
        if(typeof console !== "undefined") {
          console.info(e);
        }
      }
    }
  };

  that.commentScroller = function (buttons) {
    var _wrapper = $(buttons).closest('.tab-pane').find('.tab-inner')[0],
      wrapper = $(_wrapper),
      //child = wrapper.children('.comments'),
      //scrollMax = child.height(),
      scrollMax = wrapper.closest('.comment-display').height(),
      //scrollStep = Math.round(wrapper.height() * 0.8);
      scrollStep = Math.round(scrollMax * 0.7);

    that.showScrollButtons(buttons, scrollMax, 0, scrollStep);

    wrapper.on('scroll', function (event) {
      clearTimeout($.data(this, 'scrollTimer'));
      $.data(this, 'scrollTimer', setTimeout(function () {
        var currentPosition = Math.max(0, wrapper.scrollTop());
        that.showScrollButtons(buttons, scrollMax, currentPosition, scrollStep);
      }, 100));
    });

    $(buttons).each(function (index, item) {
      $(item).on('click', function (event) {
        event.preventDefault();

        var currentPosition = Math.max(0, wrapper.scrollTop()),
          chatScroll = currentPosition + scrollStep;

        if ($(item).hasClass('icon-scrollup')) {
          chatScroll = currentPosition - scrollStep;
        }

        wrapper.stop().animate({scrollTop: chatScroll}, 1000);

        return false;
      });
    });
  };

  that.showScrollButtons = function (buttons, max, position, step) {
    $(buttons).each(function (index, item) {
      var parent = $(item).parent().parent();

      if ($(item).hasClass('icon-scrollup')) {
        if (position === 0) {
          parent.hide();
        } else {
          parent.show();
        }
      }
    });
  };

  /**
   * Insert Comment from websocket (single_thementag)
   *
   * @param comment
   */
  that.updateVoteFromWebsocket = function (comment,total) {
    // update karma
    $('#comment-weight-value-' + comment.comment_ID).html("+" + total  + "&nbsp;");
    $('#comment-' + comment.comment_ID).attr("data-votecount",total);

    $('#comment-weight-value-top5-' + comment.comment_ID).html("+" + total  + "&nbsp;");
    $('#comment-top5-' + comment.comment_ID).attr("data-votecount",total);

    that.updateTop5FromComments();
  };

  /**
   *
   */
  that.updateTop5FromComments = function() {
    // order by data-votecount and data-commenttime
    // copy top 5

    var comments = $("#comments");
    var commentsTop5 = $("#comments-top5");
    var commentListTop5 = commentsTop5.find("> .comment-list");
    var commentListTop5Elements = commentListTop5.find(" > li");

    var commentList = [];
    comments.find("> .comment-list > li").each(function(){
      var current = $(this);
      commentList.push({id: parseInt(current.attr("data-comment-id")), el: current, votecount: parseInt(current.attr("data-votecount")), commenttime: parseInt(current.attr("data-commenttime"))});
    });
    that.sortByVotecountAndCommenttime(commentList);
    var top5Length = Math.min(that.commentsTopCount,commentList.length);

    // check if update needed
    var changed = false;
    var i;
    for(i=0;i<top5Length;i++) {
      if(commentList[i].id !== parseInt(commentListTop5Elements.eq(i).attr("data-comment-id"))) {
        changed = true;
        break;
      }
    }

    if(changed) {
      var newTop5 = [];
      for (i = 0; i < top5Length; i++) {
        var clone = commentList[i].el.clone();
        clone.attr("id", "comment-top5-" + commentList[i].id).attr("style","display:list-item");
        clone.find(".children").remove();
        clone.find(".comment-body").attr("id", "div-comment-top5-" + commentList[i].id);
        clone.find('div.comment-weight-container > span').attr("id", "comment-weight-value-top5-" + commentList[i].id);
        clone.find('div.comment-weight-container > span > a')
          .off().on('click', getLibObject("comments").addSingleVotingClickHandler);
        newTop5.push(clone);
      }
      commentListTop5.empty();
      for (i = 0; i < newTop5.length; i++) {
        commentListTop5.append(newTop5[i]);
      }
    }

    $('.tab-header-top5 > a').html('Top '+that.commentsTopCount);
  };

  that.sortByVotecountAndCommenttime = function(commentsList) {
    commentsList.sort(function (a, b) {
      if(a.votecount < b.votecount) {
        return 1;
      }
      if(a.votecount > b.votecount) {
        return -1;
      }
      // equal, check timestamp as second criteria
      if(a.commenttime < b.commenttime) {
        return 1;
      }
      if(a.commenttime > b.commenttime) {
        return -1;
      }
      return 0;
    });
  };

  that.unTrashCommentFromWebsocket = function (comment) {
    // todo
    // placeholder
  };

  /**
   * Insert Comment from websocket (single_thementag)
   *
   * @param comment
   */
  that.insertCommentFromWebsocket = function (comment) {

    var commentsContainerElement = $("#comments");
    var parent = false;

    var comment_new = "";
    var classname = "animate";
    if (typeof getLibObject("config").ajax_templates.comment !== "undefined") {

      // comment exists, replace and set voting handler again, also adds new children
      var current_comment_dom = $("#comment-" + comment.comment_ID);
      if (current_comment_dom.length > 0) {
        // this should not happen there is an extra event for update
        return;
      }

      var parentCommentId = parseInt(comment.comment_parent);
      if (parentCommentId > 0) {
        classname += " depth-2 ";
      }

      comment.comment_content = that.replaceSmileys(comment.comment_content);

      // if comment doesnt exist add it
      comment_new = getLibObject("config").ajax_templates.comment;
      comment_new = that.replaceCommentPlaceholders(
        comment_new,
        comment.comment_ID,
        comment.user_id,
        classname,
        comment.timestamp_unix,
        comment.comment_initials,
        comment.comment_author,
        comment.comment_karma,
        comment.timestamp_iso,
        comment.timestamp_formated,
        getLibObject("helper").wpautop(comment.comment_content),
        comment.comment_vimeo_timestamp,
        ""
      );

      if (parentCommentId > 0) {
        // add this comment as child of existing comment
        var currentListItem = $("#comment-" + parentCommentId);
        parent = currentListItem.find(" > .children");

        // php wont render the children ol if there are no children
        if(parent.length === 0) {
          currentListItem.append('<ol class="children"></ol>');
          parent = currentListItem.find(" > .children");
        }

        // update parent position
        // can we assume that this comment would be first now?
        // I guess so (if not we would have to check timestamps)
        var listEl = currentListItem.parent();
        listEl.prepend(currentListItem);

        // add comment as last child of parent
        parent.append(comment_new);

      } else {
        // add comment as new toplevel comment
        parent = commentsContainerElement.find(">ol");
        parent.prepend(comment_new);
      }

      $("#comment-" + comment.comment_ID).slideDown("slow")
        .find('div.comment-weight-container > span > a')
        .off()
        .on('click', getLibObject("comments").addSingleVotingClickHandler);

      that.updateTop5FromComments();
    }
  };

  /**
   * Replace Smileys-chars with Unicode
   *
   * @param text
   * @returns {string}
   */
  that.replaceSmileys = function(text) {
    var smilies = getLibObject("config").smilies;

    for (var prop in smilies) {
      var replacement = decodeURIComponent(escape(smilies[prop]));
      text = text.replaceAll(prop, replacement);
    }
    return text;
  };

  /**
   * Replace Emoji with Smileys-chars
   * to save in databse
   *
   * @param text
   * @returns {string}
   */
  that.replaceEmoji = function(text) {
    var smilies = getLibObject("config").smilies;

    for (var prop in smilies) {
      var emoji = decodeURIComponent(escape(smilies[prop]));
      text = text.replaceAll(emoji, prop);
    }

    return text;
  };

  /**
   * Update Comment from websocket (single_thementag)
   *
   * @param comment
   */
  that.updateCommentFromWebsocket = function (comment) {

    if (typeof getLibObject("config").ajax_templates.comment !== "undefined") {

      var current_comment_dom = $("#comment-" + comment.comment_ID);
      var top_comment_dom = $("#comment-top5-" + comment.comment_ID);
      if (current_comment_dom.length === 0) {
        // this should not happen there is an extra event for insert
        return;
      }

      var new_content = getLibObject("helper").wpautop(that.replaceSmileys(comment.comment_content));
      current_comment_dom.find('> .comment-body .comment-content').html(new_content);
      top_comment_dom.find('> .comment-body .comment-content').html(new_content);
    }
  };

  /**
   * Remove comment over websocket (single_thementag)
   *
   * @param commentId
   */
  that.deleteCommentFromWebsocket = function (commentId) {
    $("#comment-" + commentId).remove();
    $("#comment-top5-" + commentId).remove();
    that.updateTop5FromComments();
  };

  /**
   * Insert Comments, called by ajax polling (single_thementag)
   *
   * @param comments
   * @param parent
   */
  that.insertComments = function (comments, parent) {
    var comment_new, classname;
    var comment_ids = [];

    for (var k in comments) {
      if (comments.hasOwnProperty(k)) {
        comment_ids.push("comment-" + comments[k].comment_id);
        comment_new = "";
        classname = "animate";
        if (typeof getLibObject("config").ajax_templates.comment !== "undefined") {
          var parentId = parseInt(comments[k].comment_parent);
          if (parentId !== 0) {
            classname = " parent depth-2 ";
          }

          // comment exists, replace and set voting handler again, also adds new children
          var current_comment_dom = $("#comment-" + comments[k].comment_id);
          if (current_comment_dom.length > 0) {
            if (current_comment_dom.find(" > .children > li").length === comments[k].children.length) {
              var tmp = comments[k];
              that.replaceComment(comments[k].comment_id, tmp, parent);
              continue;
            }
            else {
              current_comment_dom.detach(); // remove and let the following code insert it again in front
            }
          }

          // if comment doesnt exist add it
          comment_new = getLibObject("config").ajax_templates.comment;
          comment_new = that.replaceCommentPlaceholders(
            comment_new,
            comments[k].comment_id,
            comments[k].user_id,
            classname,
            comments[k].timestamp_unix,
            comments[k].comment_initials,
            comments[k].comment_author,
            comments[k].comment_karma,
            comments[k].timestamp_iso,
            comments[k].timestamp_formated,
            that.replaceSmileys(comments[k].comment_content),
            comments[k].comment_vimeo_timestamp,
            false);

          var tmpChilds = "";
          for (var x in comments[k].children) {
            var child = comments[k].children[x];
            var childTemplate = getLibObject("config").ajax_templates.comment;
            childTemplate = that.replaceCommentPlaceholders(childTemplate,
              child.comment_id, child.user_id, "parent depth-2",
              child.timestamp_unix, child.comment_initials,
              child.comment_author, child.comment_karma, child.timestamp_iso,
              child.timestamp_formated,
              that.replaceSmileys(child.comment_content),
              child.comment_vimeo_timestamp,
              "");

            tmpChilds += childTemplate;
          }

          comment_new = comment_new
            .replaceAll("%%CHILDREN%%", tmpChilds);

          parent.prepend(comment_new);
          $("#comment-" + comments[k].comment_id).slideDown("slow").find('div.comment-weight-container > span > a').off().on('click', getLibObject("comments").addSingleVotingClickHandler);
        }
      }
    }
    if (comment_ids.length) {
      setTimeout(function () {
        var comment_ids2 = comment_ids;
        parent.find(">li").each(function () {
          if (jQuery.inArray($(this).attr("id"), comment_ids2) === -1) { // li not found
            $(this).remove();
          }
        });
      }, 1200);
    }
  };

  that.insertCommentsTop5 = function (comments, parent) {
    parent.find(">li").remove();
    var comment_new, classname;
    for (var k in comments) {
      if (comments.hasOwnProperty(k)) {
        comment_new = "";
        classname = "animate";
        if (typeof getLibObject("config").ajax_templates.comment !== "undefined") {
          var parentId = parseInt(comments[k].comment_parent);
          if (parentId !== 0) {
            classname = " parent depth-2 ";
          }

          comment_new = getLibObject("config").ajax_templates.comment;
          comment_new = that.replaceCommentPlaceholders(
            comment_new,
            "top5-" + comments[k].comment_id,
            comments[k].user_id,
            classname,
            comments[k].timestamp_unix,
            comments[k].comment_initials,
            comments[k].comment_author,
            comments[k].comment_karma,
            comments[k].timestamp_iso,
            comments[k].timestamp_formated,
            that.replaceSmileys(comments[k].comment_content),
            comments[k].comment_vimeo_timestamp,
            "");

          // top5 dont show children

          parent.append(comment_new);
          $("#comment-top5-" + comments[k].comment_id).show().find('div.comment-weight-container > span > a').off().on('click', getLibObject("comments").addSingleVotingClickHandler);
        }
      }
    }
  };

  that.loadPopupsFromComments = function () {
    var usedCommentIds = [];
    //var numberOfComments = 0; // zeig die neuesten 4, nicht älter als 10 min;
    //var maxNumberOfComments = 4; // zeig die neuesten 4, nicht älter als 10 min;
    var zuschauer = $("#zuschauer");
    $("#comments").find(".comment").sort(function (a, b) {
      return parseInt(b.getAttribute("data-commenttime")) - parseInt(a.getAttribute("data-commenttime"));
    }).each(function (index) {
      var user_id = parseInt($(this).attr("data-user-id"));
      if ($.inArray(user_id, usedCommentIds) === -1) { // show only latest comment
        var bubble = zuschauer.find("[data-user-id=" + user_id + "]");
        usedCommentIds[usedCommentIds.length] = user_id;
        if (bubble.length) {
          bubble = $(bubble.get(0));
          var time = $(this).find(">article time").text();
          var name = $(this).find(">article .comment-author span").text();
          var message = $(this).find(">article .comment-content").text();

          bubble.find(".user").text(name);
          bubble.find(".time").text(time);
          bubble.find(".message").text(message);
          getLibObject("comments").addZuschauerClickHandler(bubble);
          //bubble.addClass("active");
        }
      }
    });
  };

  /**
   * adds new comment from submit to comment list (temporary, till ajax save finishes)
   *
   * @param comment
   */
  that.addCommentToBox = function (comment) {
    // temp ID
    var id = getLibObject("helper").uuid();

    var comments = $("#comments");
    //var scrollTop = comments.scrollTop();
    var parent = comments.find(">ol");

    var comment_new = "";
    if (typeof getLibObject("config").ajax_templates.comment !== "undefined") {
      var user = getLibObject("user").getUser();
      var initials = "";
      if (user) { // maybe user is expired?
        initials = getLibObject("user").getInitials(user.display_name);
        comment_new = getLibObject("config").ajax_templates.comment;
        comment_new = that.replaceCommentPlaceholders(
          comment_new,
          id,
          user.ID,
          'not-saved animate',
          "",
          initials,
          user.display_name,
          0,
          "",
          "wird gespeichert ...",
          comment,
          "",
          ""
        );
      } else {
        initials = " ";
        comment_new = getLibObject("config").ajax_templates.comment;
        comment_new = that.replaceCommentPlaceholders(
          comment_new,
          id,
          "temp_user_id",
          'not-saved animate',
          "",
          initials,
          "Name",
          0,
          "",
          "wird gespeichert ...",
          comment,
          "",
          ""
        );
      }

      $("#ticker").tab('show');
      comments.parent().parent().animate(
        {
          scrollTop: 0
        }, '400');
      if(!$("#comment-" + id).length) {
        parent.prepend(comment_new);
        $("#comment-" + id).slideDown("slow");
      }
    }
    return id;
  };

  /**
   * Init comments after page load
   * - add submit handler to form
   */
  that.initComment = function () {
    if(!getLibObject("config").websocketSuccess) {
      $("#commentform").submit(function (e) {
        e.preventDefault();
        $.growl.error($.extend({title: ""}, {message: "Es ist ein Fehler aufgetreten. Ihre eingetragenen Daten wurden nicht übernommen."}));
        return false;
      });
    } else {
      $("#commentform").submit(function (e) {
        e.preventDefault();

        // Daten aus dem Form laden
        var messageTextfield = $('#comment');
        var messageTextfieldText = messageTextfield.val().trim();
        if(messageTextfieldText === "") {
          messageTextfield.val('');
          return false;
        }
        var sendToNode = {
          blogId: sage_js.blog_id,
          sessionId: ajax_variables.post_id,
          message: that.replaceEmoji(messageTextfieldText)
        };

        getLibObject("websocket").socket.emit('frontend-comment-submit', sendToNode, function (response) {
          getLibObject("helper").log(response);
        }); // Sende Event (chat message) mit dem Inhalt der Chateingabe an den Server
        messageTextfield.val('');
        return false;
      });
    }
  };

  that.replaceCommentPlaceholders = function (comment_new, id, user_id, classes, timestamp_unix, user_initials, user_display_name, karma, time_iso, commenttimeformatted, comment, comment_vimeo_timestamp, children) {

    if(!comment_vimeo_timestamp) {
      comment_vimeo_timestamp = "";
    }

    if (user_display_name === 'Online-Moderator') {
      classes += ' online-moderator ';
    }
    if (user_display_name === 'Twitter-Reporter') {
      classes += ' twitter-reporter ';
    }
    if (user_display_name === 'Fachexperte') {
      classes += ' fachexperte ';
    }
    if(comment_vimeo_timestamp) {
      classes += ' has-vimeo-timestamp ';
    }

    var comment_return = comment_new
      .replaceAll("%%COMMENTID%%", id)
      .replaceAll("%%COMMENTUSERID%%", user_id)
      .replaceAll("%%COMMENTVIMEOTIMESTAMP%%", comment_vimeo_timestamp)
      .replaceAll("%%COMMENTVIMEOHTML%%", comment_vimeo_timestamp?getLibObject("config").ajax_templates.commentVimeoPlay:"")
      .replaceAll("%%COMMENTCLASS%%", classes)
      .replaceAll("%%COMMENTTIMESTAMP%%", timestamp_unix)
      .replaceAll("%%COMMENTUSERINITIALS%%", user_initials)
      .replaceAll("%%COMMENTUSERNAME%%", user_display_name)
      .replaceAll("%%COMMENTKARMA%%", karma)
      .replaceAll("%%COMMENTTIMEC%%", time_iso)
      .replaceAll("%%COMMENTTIMEFORMATED%%", commenttimeformatted)
      .replaceAll("%%COMMENTTEXT%%", comment);
    if (children !== false) {
      comment_return = comment_return.replaceAll("%%CHILDREN%%", children);
    }
    return comment_return;
  };

  /**
   * replace comment with saved comment from ajax save
   *
   * @param oldId
   * @param comment
   * @param parent
   */
  that.replaceComment = function (oldId, comment, parent) {
    setTimeout(function () {
      var classname = '';
      var comment_new = getLibObject("config").ajax_templates.comment;
      comment_new = that.replaceCommentPlaceholders(
        comment_new, comment.comment_id, comment.user_id, classname,
        comment.timestamp_unix, comment.comment_initials, comment.comment_author,
        comment.comment_karma, comment.timestamp_iso, comment.timestamp_formated,
        that.replaceSmileys(comment.comment_content),
        comment.comment_vimeo_timestamp,
        false);

      var tmpChilds = "";
      for (var x in comment.children) {
        var child = comment.children[x];
        var childTemplate = getLibObject("config").ajax_templates.comment;
        childTemplate = that.replaceCommentPlaceholders(childTemplate,
          child.comment_id,
          child.user_id,
          "parent depth-2",
          child.timestamp_unix,
          child.comment_initials,
          child.comment_author,
          child.comment_karma,
          child.timestamp_iso,
          child.timestamp_formated,
          that.replaceSmileys(child.comment_content),
          child.comment_vimeo_timestamp,
          "");

        tmpChilds += childTemplate;
      }

      comment_new = comment_new
        .replaceAll("%%CHILDREN%%", tmpChilds);

      var oldComment = $(parent).find("#comment-" + oldId);
      if (oldComment.length) {
        oldComment.replaceWith(comment_new);
      } else {
        // $("#comments > ol").prepend(comment_new); // not sure how to handle timing here
      }
      $(parent).find("#comment-" + comment.comment_id + ' div.comment-weight-container > span > a').off().on('click', getLibObject("comments").addSingleVotingClickHandler);

    }, 1000);
  };

  that.refreshZuschauer = function () {
    var zuschauerNeu = $("#zuschauer-reload");
    var zuschauer = $("#zuschauer");
    if (zuschauerNeu.length) {
      var count = zuschauerNeu.attr("data-zuschauer-count");
      if (count !== "") {
        zuschauer.find(".user-counter").removeClass("hide").hide();
        zuschauer.find(".counter").text(count);
        if (count === "1") {
          zuschauer.find(".user-counter.single").show();
        } else {
          zuschauer.find(".user-counter.multi").show();
        }
      }
      var li = zuschauerNeu.find("li").detach();
      var container = zuschauer.find(".bubble-container");
      container.find("li").remove();
      li.appendTo(container);
    }
  };

  that.addZuschauerClickHandler = function (elem) {
    if (elem.length) {
      elem.off().on("click", function () {
        if (!$(this).hasClass("active")) {
          // close all
          $("#zuschauer").find(".bubble").removeClass("active");
        }
        elem.toggleClass("active");
      });
    }
  };

  that.disableCommentTab = function () {
    var tabs = $(".comment-tabs");
    tabs.find(".tab-pane-comments").addClass("hide").removeClass("active");
    tabs.find(".tab-header-comments").addClass("hide").removeClass("active");
    tabs.find(".tab-pane-top5").addClass("active");
    tabs.find(".tab-header-top5 ").addClass("active full-width");
  };

  that.enableCommentTab = function () {
    var tabs = $(".comment-tabs");
    tabs.find(".tab-pane-comments").removeClass("hide");
    tabs.find(".tab-pane-comments").addClass("active");
    tabs.find(".tab-header-comments").removeClass("hide");
    tabs.find(".tab-header-comments").addClass("active");
    tabs.find(".tab-header-comments").attr("aria-expanded", "true");
    //tabs.find(".tab-pane-top5").removeClass("");
    tabs.find(".tab-header-top5 ").removeClass("full-width");
    tabs.find(".tab-header-top5 ").removeClass("active");
    tabs.find(".tab-header-top5 ").attr("aria-expanded", "false");
    tabs.find(".tab-pane-top5 ").removeClass("active");
  };

  that.renderModComment = function(comment,commentHtml) {
    var commentHotClass = "";
    var commentHighlightClass = "";
    var commentStageDirection = "";
    var commentStageDirectionClass = "";

    if (comment.meta.comment_hot) {
      commentHotClass = "state-is-hot";
    }
    if (comment.meta.comment_highlight) {
      commentHighlightClass = "state-is-highlight";
    }

    if (comment.meta.comment_stage_direction) {
      commentStageDirection = comment.meta.comment_stage_direction;
      commentStageDirectionClass = "state-has-stage-direction";
    }

    commentHtml = commentHtml
      .replaceAll("%%COMMENT_ID%%", comment.comment_ID)
      .replaceAll("%%COMMENT_KARMA%%", comment.comment_karma)
      .replaceAll("%%COMMENT_CONTENT%%", getLibObject("helper").wpautop(that.replaceSmileys(comment.comment_content).replace(/<[^>]*>?/gm, '')))
      .replaceAll("%%COMMENT_AUTHOR%%", comment.comment_author)
      .replaceAll("%%COMMENT_STAGE_DIRECTION%%", getLibObject("helper").wpautop(commentStageDirection))
      .replaceAll("%%COMMENT_HAS_STAGE_DIRECTION%%", commentStageDirectionClass)
      .replaceAll("%%COMMENT_HIGHLIGHT%%", commentHighlightClass)
      .replaceAll("%%COMMENT_HOT%%", commentHotClass);
    return commentHtml;
  };

  that.modCommentCreateInitialView = function (comments,listEl,emptyEl) {

    if(comments.length) {
      var commentsFiltered = that.modCommentGetOrderedAndFilteredComments(comments);

      $.each(commentsFiltered, function (index, comment) {
        var commentHtml = that.renderModComment(comment,getLibObject('config').ajax_templates.modComment);
        listEl.append(commentHtml);
      });

      if(commentsFiltered.length) {
        emptyEl.hide();
      }

      that.modCommentInitSwipeout(listEl,".task1");
      that.modCommentInitHighlight(listEl);
    }
  };

  that.modCommentFilter = function (comment) {
    return parseInt(comment.comment_approved) === 1 && parseInt(comment.comment_parent) === 0 &&
      !comment.meta.comment_removed &&
      (comment.meta.comment_chosen || comment.meta.comment_hot);
  };

  that.modCommentOrder = function (commentA, commentB) {

    if(commentA.meta.comment_hot && !commentB.meta.comment_hot) {
      return -1;
    }
    if(!commentA.meta.comment_hot && commentB.meta.comment_hot) {
      return 1;
    }

    // equally hot
    if(commentA.comment_karma > commentB.comment_karma) {
      return -1;
    }
    if(commentA.comment_karma < commentB.comment_karma) {
      return 1;
    }

    return 0;
  };

  that.modCommentInitSwipeout = function (listEl, selector) {
    var myApp = new Framework7();
    var $$ = Dom7;

    // wont work:
    // listEl.on('click', selector, that.modCommentClickHandler );
    listEl.find(selector).on('click', that.modCommentClickHandler );
  };

  that.modCommentInitHighlight = function (listEl) {
    listEl.on('click', ".comment-highlight-enable", that.modCommentHighlightHandlerEnable );
    listEl.on('click', ".comment-highlight-disable", that.modCommentHighlightHandlerDisable );
  };

  that.modCommentClickHandler = function () {
    var comment_ID = jQuery(this).attr("data-comment-id");

    // update directly to prevent strange timing problems (like update function called before this ajax-call is finished)
    //that.currentModComments[parseInt(comment_ID)].meta.comment_removed = true;

    var sendToNode = {
      blogId: sage_js.blog_id,
      sessionId: window.sessionId,
      message: {
        commentId: comment_ID,
        comment_removed: 1
      }
    };
    getLibObject("helper").log(sendToNode);

    var eventName = 'frontend-commentremoved-activate';

    getLibObject("websocket").socket.emit(eventName, sendToNode);
  };

  that.modCommentHighlightHandlerEnable = function (e) {
    e.preventDefault();
    that.modCommentHighlightHandler($(this), true);
  };
  that.modCommentHighlightHandlerDisable = function (e) {
    e.preventDefault();
    that.modCommentHighlightHandler($(this), false);
  };

  that.modCommentHighlightHandler = function (buttonEl, newValue) {
    var commentEl = buttonEl.closest(".mod-comment");
    var commentId = parseInt(commentEl.attr("data-comment-id"));

    var sendToNode = {
      blogId: sage_js.blog_id,
      sessionId: window.sessionId,
      message: {
        commentId: commentId,
        highlight: newValue
      }
    };
    getLibObject("helper").log(sendToNode);

    var eventName = 'frontend-commenthighlight-activate';
    if(!newValue) {
      eventName = 'frontend-commenthighlight-deactivate';
    }
    getLibObject("websocket").socket.emit(eventName, sendToNode); // Sende Event (chat message) mit dem Inhalt der Chateingabe an den Server
  };

  /**
   *
   * @param commentId
   */
  that.modCommentRemoveFromDashboard = function(commentId) {
    $('#comment-' + commentId).remove();
  };

  /**
   *
   * @param commentId
   */
  that.modCommentUpdateDashboard = function(commentId) {
    var comments = that.modCommentGetOrderedAndFilteredComments(that.modCommentGetCurrentModCommentsAsArray());
    var commentEl = false;
    var previousEl = false;
    var listEl = $("#mod-comments-list");
    var emptyEl = $("#mod-comments-empty-message");

    if(comments.length === 0) {
      emptyEl.show();
    } else {
      emptyEl.hide();
    }

    // reorder
    // changed properties should already be changed
    // new comments should already be present
    for(var i=0;i<comments.length;i++) {
      commentEl = $("#comment-" + comments[i].comment_ID);
      if(commentEl.index() !== i) {
        if(!previousEl) {
          listEl.prepend(commentEl);
        } else {
          previousEl.after(commentEl);
        }
      }
      previousEl = commentEl;
    }
  };

  that.modCommentGetCurrentModCommentsAsArray = function() {
    return Object.values(that.currentModComments);
  };

  that.modCommentGetOrderedAndFilteredComments = function(comments) {
    var commentsFiltered = comments.filter(that.modCommentFilter);
    // orders in place
    commentsFiltered.sort(that.modCommentOrder);
    return commentsFiltered;
  };

  /**
   *
   * @param commentId
   * @param property
   * @param value
   */
  that.modCommentUpdateState = function(commentId,property,value) {
    // possible metas:
    var availableMetas = [
      'comment_chosen',
      'comment_hot',
      'comment_removed',
      'comment_marked',
      'comment_highlight',
      'comment_stage_direction',
      'comment_vimeo_timestamp'
    ];

    var availableFields = [
      'comment_karma'
    ];

    if(that.currentModComments[commentId]) {
      if (!that.currentModComments[commentId].meta) {
        that.currentModComments[commentId].meta = {};
      }
      if (availableMetas.includes(property)) {
        that.currentModComments[commentId].meta[property] = value;
      } else if (availableFields.includes(property)) {
        that.currentModComments[commentId][property] = value;
      }
    }
  };

  /**
   * determine if comment should be visible or not
   * checks comment_chosen and comment_hot
   * @param commentId
   * @returns {boolean}
   */
  that.modCommentIsCommentVisible = function(commentId) {
    if (that.currentModComments[commentId]) {
      if(that.currentModComments[commentId].meta.comment_chosen ||
        that.currentModComments[commentId].meta.comment_hot ) {
        return true;
      }
    }
    return false;
  };

  that.modCommentUpdateDom = function(commentId,property,value) {
    var commentEl = $("#comment-" + commentId);
    var listEl = $("#mod-comments-list");

    // comment exists
    if(commentEl.length) {
      if(property === "comment_hot") {
        if(value) {
          commentEl.addClass("state-is-hot");
        } else {
          commentEl.removeClass("state-is-hot");
        }
      }
      if(property === "comment_stage_direction") {
        if(value) {
          commentEl.addClass("state-has-stage-direction");
          commentEl.find(".sd-content").html(getLibObject('helper').wpautop(value));
        } else {
          commentEl.removeClass("state-has-stage-direction");
          commentEl.find(".sd-content").html("");
        }
      }
      if(property === "comment_karma") {
        commentEl.find("> .item-content .comment-weight-value").html("+" + value + "&nbsp;");
      }
      if(property === "comment_content") {
        if(value !== '') {
          commentEl.find('> .item-content .comment-content').html(getLibObject('helper').wpautop(getLibObject('comments').replaceSmileys(value)));
        }
      }
    } else {
      // comment does not exist
      var comment = that.currentModComments[commentId];
      // check if comment should exist
      if(comment && that.modCommentFilter(comment)) {
        // insert
        var commentHtml = that.renderModComment(comment,getLibObject('config').ajax_templates.modComment);
        listEl.append(commentHtml);
        commentEl = $("#comment-" + commentId);
        commentEl.find(".task1").on('click', that.modCommentClickHandler );
      }
    }

    if(that.modCommentIsCommentVisible(commentId)) {
      commentEl.removeClass("hide");
    } else {
      commentEl.addClass("hide");
    }
  };

  /**
   *
   * @param comment
   */
  that.modCommentUpdateStateFull = function(comment) {
    that.currentModComments[comment.comment_ID] = comment;
  };

  /**
   *
   * @param comment
   * @param changedProperty
   */
  that.modCommentAddToDashboard = function(comment, changedProperty) {

  };

  that.initSessionComments = function(comments) {
    var parent = $('#ticker .comment-list');

    //parent.html('');
    for(var i = 0; i < comments.length; i++) {
      that.insertCommentFromWebsocket(comments[i]);
    }

    that.updateTop5FromComments();
  };

  that.fieldChangedInfotext = function(value) {
    var text = getLibObject("helper").wpautop(value);
    text = text.replace(/\\/g, '');
    $('.comment-infotext').html(text);
  };

  that.fieldChangedInfotextActivate = function(value) {
    var el_player = jQuery('#player');

    if(value[0] === 'true') {
      el_player.find('.comment-disabled-area').show();
      el_player.find('.comment-enabled-area').hide();
    } else {
      el_player.find('.comment-disabled-area').hide();
      el_player.find('.comment-enabled-area').show();
    }
  };

  that.fieldChangedChatbutton = function(value) {
    if($('#chatButton').length) {
      var button = '';

      if(value.url && value.title) {
        button = '<a class="btn btn-primary" href="'+value.url+'" target="'+value.target+'">'+value.title+'</a>';
      }

      $('#chatButton').html(button);
    }
  };

  that.disableChatInput = function(){
    var el_commentline = $('#commentline');
    el_commentline.find(' #comment').attr("placeholder", "Nur für Kunden freigeschaltet!");
    el_commentline.find(' #comment').attr("disabled", "disabled");
    el_commentline.find(' #comment').css("padding-right", "0");
    el_commentline.find(' .char-counter').hide();
    el_commentline.find(' #submit').attr("disabled", "disabled");
    el_commentline.addClass('chat-restricted');
  };

  window.vrnetworld.comments = that;
})(jQuery);
